import '../financials/financialsResponsive.css';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const TILES = [
    {
        icon: '📄',
        title: 'Invoicing',
        description: 'Create and manage client invoices',
        color: 'bg-[var(--nav-active-bg)]',
        path: '/financials/invoicing',
    },
    {
        icon: '🔄',
        title: 'Auto-Billing',
        description: 'Set up recurring billing schedules',
        color: 'bg-[var(--nav-active-bg)]',
        path: '/financials/auto-billing',
    },
    {
        icon: '💵',
        title: 'Payments',
        description: 'Record and track incoming payments',
        color: 'bg-[var(--nav-active-bg)]',
        path: '/financials/payments',
    },
    {
        icon: '📆',
        title: 'Scheduled Payments',
        description: 'Manage future and recurring payment schedules',
        color: 'bg-[var(--nav-active-bg)]',
        path: '/financials/scheduled-payments',
    },
    {
        icon: '📊',
        title: 'Transactions',
        description: 'View and categorise all financial transactions',
        color: 'bg-blue-100',
        path: '/financials/transactions',
    },
    {
        icon: '📖',
        title: 'Chart of Accounts',
        description: 'Manage your full chart of accounts',
        color: 'bg-blue-100',
        path: '/financials/chart-of-accounts',
    },
];

function FinancialsHubView({ theme = 'light' }) {
    const navigate = useNavigate();

    return (
        <div className="ia-financials max-w-4xl mx-auto">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {TILES.map(({ icon, title, description, color, path }) => (
                    <div
                        key={path}
                        role="button"
                        tabIndex={0}
                        onClick={() => navigate(path)}
                        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); navigate(path); } }}
                        className={`rounded-lg border p-5 hover:shadow-lg transition-all cursor-pointer group ${
                            theme === 'dark'
                                ? 'bg-gray-800 border-gray-700'
                                : 'bg-white border-gray-200'
                        }`}
                    >
                        <div className="flex items-start gap-4">
                            <div className={`w-12 h-12 rounded-lg flex items-center justify-center text-2xl flex-shrink-0 ${color}`}>
                                {icon}
                            </div>
                            <div className="flex-1">
                                <h3 className={`font-semibold mb-1 group-hover:text-[var(--accent-ink-hover)] transition ${
                                    theme === 'dark' ? 'text-gray-100' : 'text-gray-900'
                                }`}>{title}</h3>
                                <p className={`text-sm ${
                                    theme === 'dark' ? 'text-gray-400' : 'text-gray-600'
                                }`}>{description}</p>
                            </div>
                            <div className={`text-xl ${theme === 'dark' ? 'text-gray-500' : 'text-gray-400'}`}>›</div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default FinancialsHubView;
